import React, { useEffect, useState } from "react";
import { getregulatorydata, addorupdateregulatorydata } from "../../../Services/UserService/clientService";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Loader from "../../../../Utils/Loader";

const Regulatory = () => {
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("id");

    const [regulatoryData, setRegulatoryData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getsettingdetail = async () => {
        try {
            setIsLoading(true)
            const response = await getregulatorydata(token);
            if (response.status) {
                setRegulatoryData(response.data || {});
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        getsettingdetail();
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    // Validation schema using Yup
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Company Name is required"),
        head_office: Yup.string().required("Head Office is required"),
        regional_office: Yup.string().required("Regional Office is required"),
        address: Yup.string().required("Address is required"),
        contact_number: Yup.string()
            .required("Contact Number is required"),
        registration_number: Yup.string().required("Registration Number is required"),
        registration_validity: Yup.date().required("Registration Validity is required"),
        type_of_registration: Yup.string().required("Type of Registration is required"),
        principal_officer_name: Yup.string().required("Principal Officer Name is required"),
        principal_officer_contact: Yup.string()
            .required("Principal Officer Contact is required"),
        principal_officer_email: Yup.string()
            .required("Principal Officer Email is required")
            .email("Invalid email format"),
        disclaimer: Yup.string().required("Disclaimer is required"),
        warning: Yup.string().required("Warning is required"),
    });

    return (
        <div className="page-content">
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Regulatory Information</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />

            <Formik
                enableReinitialize={true}
                initialValues={{
                    name: regulatoryData.name || "",
                    head_office: regulatoryData.head_office || "",
                    regional_office: regulatoryData.regional_office || "",
                    address: regulatoryData.address || "",
                    contact_number: regulatoryData.contact_number || "",
                    registration_number: regulatoryData.registration_number || "",
                    registration_validity: regulatoryData.registration_validity || "",
                    type_of_registration: regulatoryData.type_of_registration || "",
                    principal_officer_name: regulatoryData.principal_officer_name || "",
                    principal_officer_contact: regulatoryData.principal_officer_contact || "",
                    principal_officer_email: regulatoryData.principal_officer_email || "",
                    disclaimer: regulatoryData.disclaimer || "",
                    warning: regulatoryData.warning || "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    const req = {
                        ...values,
                        id: user_id,
                        _id: regulatoryData._id,
                    };

                    try {
                        const response = await addorupdateregulatorydata(req, token);
                        if (response.status) {
                            showCustomAlert("Success", response.message);
                            getsettingdetail();
                        } else {
                            showCustomAlert("Error", response.message);
                        }
                    } catch (error) {
                        showCustomAlert("Error", "Unexpected error occurred");
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {({ dirty, isSubmitting }) => (
                    <Form>

                        {/* Section 1: Company Details */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-light fw-bold">Company Details</div>
                            <div className="card-body p-3">
                                {[
                                    { label: "Company Name", name: "name", type: "text" },
                                    { label: "Head Office", name: "head_office", type: "text" },
                                    { label: "Regional Office", name: "regional_office", type: "text" },
                                    { label: "Address", name: "address", type: "text" },
                                    { label: "Contact Number", name: "contact_number", type: "text" },
                                ].map((field, idx) => (
                                    <div className="row mb-2" key={idx}>
                                        <label className="col-sm-3 col-form-label">{field.label}</label>
                                        <div className="col-sm-9">
                                            <Field name={field.name} type={field.type} className="form-control" />
                                            <div className="text-danger"><ErrorMessage name={field.name} /></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section 2: Registration Details */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-light fw-bold">Registration Details</div>
                            <div className="card-body p-3">
                                {[
                                    { label: "Registration Number", name: "registration_number", type: "text" },
                                    { label: "Registration Validity", name: "registration_validity", type: "date" },
                                    { label: "Type of Registration", name: "type_of_registration", type: "text" },
                                ].map((field, idx) => (
                                    <div className="row mb-2" key={idx}>
                                        <label className="col-sm-3 col-form-label">{field.label}</label>
                                        <div className="col-sm-9">
                                            <Field name={field.name} type={field.type} className="form-control" />
                                            <div className="text-danger"><ErrorMessage name={field.name} /></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section 3: Principal Officer Details */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-light fw-bold">Principal Officer Details</div>
                            <div className="card-body p-3">
                                {[
                                    { label: "Principal Officer Name", name: "principal_officer_name", type: "text" },
                                    { label: "Principal Officer Contact", name: "principal_officer_contact", type: "text" },
                                    { label: "Principal Officer Email", name: "principal_officer_email", type: "email" },
                                ].map((field, idx) => (
                                    <div className="row mb-2" key={idx}>
                                        <label className="col-sm-3 col-form-label">{field.label}</label>
                                        <div className="col-sm-9">
                                            <Field name={field.name} type={field.type} className="form-control" />
                                            <div className="text-danger"><ErrorMessage name={field.name} /></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section 4: Additional Information */}
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-light fw-bold">Additional Information</div>
                            <div className="card-body p-3">
                                {[
                                    { label: "Disclaimer", name: "disclaimer", component: "textarea" },
                                    { label: "Warning", name: "warning", component: "textarea" },
                                ].map((field, idx) => (
                                    <div className="row mb-2" key={idx}>
                                        <label className="col-sm-3 col-form-label">{field.label}</label>
                                        <div className="col-sm-9">
                                            <Field
                                                as={field.component}
                                                name={field.name}
                                                className="form-control"
                                                rows={4}
                                            />
                                            <div className="text-danger"><ErrorMessage name={field.name} /></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-sm-12 text-end">
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4"
                                    disabled={!dirty || isSubmitting}
                                >
                                    {isSubmitting ? "Updating..." : "Update"}
                                </button>
                            </div>
                        </div>

                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default Regulatory;
